import React, { useState } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";

export default function FAQSection() {
  const faqs = [
    {
      q: "Pellentesque nam eu libero himenaeos nibh viverra semper?",
      a: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus et massa vel felis placerat euismod.",
    },
    {
      q: "Elit massa finibus consequat commodo hac vel?",
      a: "Curabitur nec lacus fermentum, bibendum urna eget, finibus sapien.",
    },
    {
      q: "Facilisis primis curae hendrerit nostra augue himenaeos tempus?",
      a: "Praesent volutpat justo id mi hendrerit, a elementum velit luctus.",
    },
    {
      q: "Maximus integer urna molestie porta vel habitasse gravida?",
      a: "Suspendisse potenti. Integer semper libero nec dolor aliquam, sed luctus libero pretium.",
    },
    {
      q: "Condimentum gravida felis vitae eu?",
      a: "Mauris convallis turpis et velit porttitor, sed tempus nibh rhoncus.",
    },
  ];

  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="w-full bg-white py-14 px-6 flex flex-col md:flex-row gap-10 items-start justify-center max-w-7xl mx-auto">
      {/* Left Content */}
      <div className="w-full md:w-1/3">
        <h4 className="text-sm font-bold text-red-500 tracking-wide">FAQ</h4>
        <h2 className="text-3xl font-bold text-gray-900 mt-2 leading-snug">
          Frequently Ask<br /> Questions.
        </h2>
        <p className="text-gray-600 mt-4 leading-relaxed">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo.
        </p>
      </div>

      {/* Right Accordion */}
      <div className="w-full md:w-2/3 space-y-4">
        {faqs.map((item, index) => (
          <div key={index} className="border rounded-lg bg-gray-50 shadow-sm">
            <button
              className="w-full flex justify-between items-center p-4 text-left text-gray-800 font-medium"
              onClick={() => toggleFAQ(index)}
            >
              {item.q}
              {openIndex === index ? (
                <ChevronUp className="text-green-500" />
              ) : (
                <ChevronDown className="text-green-500" />
              )}
            </button>

            {openIndex === index && (
              <div className="px-4 pb-4 text-gray-600 leading-relaxed animate-fadeIn">
                {item.a}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
